export const NEWS_BLOCK_FETCH = 'newsblock/NEWS_BLOCK_FETCH';
export const NEWS_BLOCK_FETCHED = 'newsblock/NEWS_BLOCK_FETCHED';
export const NEWS_BLOCK_ERROR = 'newsblock/NEWS_BLOCK_ERROR';
export const NEWS_BLOCK_COOKIE = 'newsblock/NEWS_BLOCK_COOKIE';
